import { Btn, Field } from '@/components/ui';
import { NavIcon } from '@/components/icons/NavIcon';

import type { DiffItem } from './infoTabFields';
import styles from './InfoTab.module.css';

interface ChangeSummaryCardProps {
  diffs: DiffItem[];
  isAdmin: boolean;
  reason: string;
  onChangeReason: (value: string) => void;
  submitting: boolean;
  onReset: () => void;
  onSubmit: () => void;
}

// 변경 사항 카드 — diff 목록 + 변경 사유 + 저장/요청 액션.
export default function ChangeSummaryCard({
  diffs,
  isAdmin,
  reason,
  onChangeReason,
  submitting,
  onReset,
  onSubmit,
}: ChangeSummaryCardProps) {
  const isDirty = diffs.length > 0;

  return (
    <div
      className={`${styles.card} ${isDirty ? styles.dirty : ''}`}
      style={{ padding: 0 }}
    >
      <div className={styles.dirtyHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div className={styles.sectionInline}>변경 사항</div>
          {isDirty ? (
            <span className={styles.diffBadge}>{diffs.length}개 필드</span>
          ) : (
            <span className={styles.diffEmpty}>변경된 항목이 아직 없어요</span>
          )}
        </div>
        <Btn variant="ghost" size="sm" disabled={!isDirty} onClick={onReset}>
          모두 되돌리기
        </Btn>
      </div>
      {isDirty && (
        <div className={styles.diffBody}>
          <div className={styles.diffList}>
            {diffs.map((d, i) => (
              <div key={`${d.scope}-${d.field}-${i}`} className={styles.diffRow}>
                <span className={styles.diffScope}>{d.scope}</span>
                <span className={styles.diffField}>{d.field}</span>
                <span className={styles.diffBefore}>{d.before}</span>
                <span className={styles.diffAfter}>
                  <NavIcon name="chev-r" color="#9B9B9B" size={10} />
                  {d.after}
                </span>
              </div>
            ))}
          </div>
          <Field
            label="변경 사유"
            required
            textarea
            rows={3}
            placeholder="이 변경이 필요한 이유와 영향 범위를 적어주세요"
            value={reason}
            onChange={onChangeReason}
          />
          <div className={styles.actionRow}>
            <Btn variant="default" onClick={onReset} disabled={submitting}>
              취소
            </Btn>
            <Btn
              variant="primary"
              onClick={onSubmit}
              disabled={submitting || (!isAdmin && !reason.trim())}
            >
              {submitting
                ? '전송 중...'
                : isAdmin
                  ? '변경 사항 저장'
                  : '변경 요청 보내기'}
            </Btn>
          </div>
        </div>
      )}
    </div>
  );
}
